import $ from 'jquery';

const prompt = (title, textBody, callback) => {
    promptImpl(false, title, textBody, callback);
};

const promptWithIcon = (title, htmlBody, iconClass, callback) => {
    promptImpl(true, title, htmlBody, callback, iconClass);
};

const promptImpl = (bodyIsHtml, title, body, callback, icon) => {
    if (typeof(body) === 'function' && !callback) {
        callback = body;
        body = title;
        title = '';
    }

    var html = ['<div class="modal fade" style="z-index: 99999999999;">',
        '<div class="modal-dialog">',
        '  <div class="modal-content">',
        '    <div class="modal-header">',
        '      <h4 class="modal-title">Modal title</h4>',
        '      <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button>',
        '    </div>',
        '    <div class="modal-body">',
        '      <p></p>',
        '    </div>',
        '    <div class="modal-footer">',
        '      <button type="button" class="btn btn-default" data-dismiss="modal">' + MDB.loadResourceString('Bool_No') + '</button>',
        '      <button type="button" class="btn btn-primary">' + MDB.loadResourceString('Bool_Yes') + '</button>',
        '    </div>',
        '  </div><!-- /.modal-content -->',
        '</div><!-- /.modal-dialog -->',
        '</div>'].join('');

    html = $(html);
    var titleElement = html.find('.modal-title');

    if (!title) {
        titleElement.remove();
    } else {
        if (icon) {
            html.find('.modal-title').html('<i class="' + icon + '"></i> ' + title);
        } else {
            titleElement.text(title);
        }
    }


    if(bodyIsHtml) {
        html.find('.modal-body p').append(body);
    } else {
        html.find('.modal-body p').text(body);
    }

    html.bind('hidden.bs.modal', function() {
        html.remove();
        html = null;
    });
    html.find('.btn-default').bind('click', function() {
        callback(false);
    });
    html.find('.btn-primary').bind('click', function () {
        html.modal('hide');
        callback(true);
    });
    html.appendTo('body');
    html.modal('show');
};

// const prompt = (title, textBody, callback) => MDB.prompt(title, textBody, callback);
// const promptWithIcon = (title, htmlBody, iconClass, callback) => MDB.promptWithIcon(title, htmlBody, iconClass, callback);
// const promptHtml = (title, htmlBody, callback) => MDB.promptHtml(title, htmlBody, callback);

//Wrappers working with promises
//AKA Promptmise
const generatePromptV2Callback = (resolve, reject) => {
    return (ok) => {
        if(ok){
            resolve();
        } else {
            reject();
        }
    };
};

const promptV2 = (title, textBody) => { 
    return new Promise((resolve, reject) => {
        prompt(title, textBody, generatePromptV2Callback(resolve, reject));
    });
};

// const promptHtmlV2 = (title, htmlBody) => {
//     return new Promise((resolve, reject) => {
//         promptHtml(title, htmlBody, generatePromptV2Callback(resolve, reject));
//     });
// };

const promptWithIconV2 = (title, htmlBody, iconClass) => {
    return new Promise((resolve, reject) => {
        promptWithIcon(title, htmlBody, iconClass, generatePromptV2Callback(resolve, reject));
    });
};


export {
    prompt,
    // promptHtml,
    promptWithIcon,
    promptV2,
    // promptHtmlV2,
    promptWithIconV2
};

export default {
    prompt,
    // promptHtml,
    promptWithIcon,
    promptV2,
    // promptHtmlV2,
    promptWithIconV2
};